module.exports = __webpack_public_path__ + "img/bg2.e254323d.jpg";